import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const tileVariants = cva(css.tile, {
  variants: {
    variant: {
      grey: 'bg-white/10',
      dark: 'bg-transparent',
    },
  },
});

interface TileProps
  extends HTMLAttributes<HTMLDivElement>,
    PropsWithChildren,
    VariantProps<typeof tileVariants> {
  isActive?: boolean;
}

const Tile = forwardRef<HTMLDivElement, TileProps>(
  ({ children, isActive, variant = 'grey', ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(css.tile, props.className, tileVariants({ variant }))}
      >
        {/* {false && (
          <div className={css.activeWrapper}>
            <div className={css['tile--active']}></div>
            <span
              className={cn(css.borderGradient, css['borderGradient--first'])}
            ></span>
            <span
              className={cn(css.borderGradient, css['borderGradient--second'])}
            ></span>
          </div>
        )} */}
        {children}
      </div>
    );
  },
);

export { Tile };
